import React from "react";
import { Link } from "react-router-dom";

const listContent = [
  "Marketingstrategie/Branding",
"Ads und Marketing",
"Kassensystemanbindung",
"Einkaufsunterstützung",
"Konzeption Vorbestellungssoftware",
"Return-on-invest Kalkulation",
"Allgemeine Prozessdigitalisierung",
]

const ListOne = () => {
  return (
    <ul
      className="ptf-services-list ptf-services-list--style-5"
      style={{ "--ptf-font-family": "var(--ptf-primary-font)" }}
    >
      {listContent.map((val, i) => (
        <li key={i}>
          <Link to="/service">{val}</Link>
        </li>
      ))}
    </ul>
  );
};

export default ListOne;
